import React from "react";
import Icon from "../../../components/AppIcon";
import { Button } from "../../../components/ui/Button";
import { formatCurrency } from "../../../utils/localization";

const BalanceCard = ({ balance }) => {
  const getBalanceType = (amount) => {
    if (amount > 0) return "owed";
    if (amount < 0) return "owes";
    return "settled";
  };

  const getBalanceColor = (amount) => {
    if (amount > 0) return "text-success";
    if (amount < 0) return "text-error";
    return "text-muted-foreground";
  };

  const getBalanceIcon = (amount) => {
    if (amount > 0) return "TrendingUp";
    if (amount < 0) return "TrendingDown";
    return "Minus";
  };

  const getBalanceText = (amount) => {
    if (amount > 0) return "You are owed";
    if (amount < 0) return "You owe";
    return "Settled up";
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 transition-all duration-200 hover:shadow-subtle">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
            <span className="text-sm font-medium text-primary-foreground">
              {balance?.user?.name?.charAt(0)?.toUpperCase()}
            </span>
          </div>
          <div>
            <h4 className="font-medium text-foreground">
              {balance?.user?.name}
            </h4>
            <p className="text-sm text-muted-foreground">
              {balance?.user?.email}
            </p>
          </div>
        </div>
        <div
          className={`flex items-center space-x-1 ${getBalanceColor(
            balance?.amount
          )}`}
        >
          <Icon name={getBalanceIcon(balance?.amount)} size={16} />
        </div>
      </div>
      <div className="mb-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">
            {getBalanceText(balance?.amount)}
          </span>
          <span
            className={`text-lg font-semibold ${getBalanceColor(
              balance?.amount
            )}`}
          >
            {balance?.amount !== 0 ? formatCurrency(balance?.amount) : "₹0.00"}
          </span>
        </div>
      </div>
      {balance?.events && balance?.events?.length > 0 && (
        <div className="mb-3">
          <div className="text-xs text-muted-foreground mb-2">
            Related Events
          </div>
          <div className="space-y-1">
            {balance?.events?.slice(0, 2)?.map((event, index) => (
              <div
                key={index}
                className="flex items-center justify-between text-xs"
              >
                <span className="text-foreground truncate flex-1 mr-2">
                  {event?.name}
                </span>
                <span
                  className={`font-medium ${getBalanceColor(event?.amount)}`}
                >
                  {formatCurrency(event?.amount)}
                </span>
              </div>
            ))}
            {balance?.events?.length > 2 && (
              <div className="text-xs text-muted-foreground">
                +{balance?.events?.length - 2} more events
              </div>
            )}
          </div>
        </div>
      )}
      {balance?.amount !== 0 && (
        <div className="pt-3 border-t border-border">
          <Button
            variant={balance?.amount > 0 ? "default" : "outline"}
            size="sm"
            fullWidth
            iconName={balance?.amount > 0 ? "DollarSign" : "Send"}
            iconPosition="left"
          >
            {balance?.amount > 0 ? "Request Payment" : "Settle Up"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default BalanceCard;
